export default "__VITE_ASSET__1e358f58__"